module.exports = __webpack_public_path__ + "img/bus-ticket.2cd342c9.svg";